var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.82 2.05L13.82 0.0500013H13.75C13.7035 0.0453229 13.6566 0.0453229 13.61 0.0500013H13.38H13.25H13.18L7.5 2L1.82 0.0500013C1.66962 0.00041287 1.50961 -0.0127533 1.35314 0.0115861C1.19667 0.0359256 1.04822 0.097075 0.920003 0.190001C0.790762 0.282018 0.685268 0.403464 0.612238 0.544308C0.539208 0.685152 0.500737 0.841351 0.500003 1V15C0.499462 15.2096 0.564822 15.4142 0.686845 15.5846C0.808868 15.7551 0.981382 15.8829 1.18 15.95L7.18 17.95C7.38145 18.0157 7.59856 18.0157 7.8 17.95L13.5 16.05L19.18 18C19.2862 18.0144 19.3938 18.0144 19.5 18C19.7091 18.0029 19.9132 17.9361 20.08 17.81C20.2092 17.718 20.3147 17.5965 20.3878 17.4557C20.4608 17.3148 20.4993 17.1587 20.5 17V3C20.5005 2.79036 20.4352 2.58585 20.3132 2.41537C20.1911 2.2449 20.0186 2.11709 19.82 2.05ZM6.5 15.61L2.5 14.28V2.39L6.5 3.72V15.61ZM12.5 14.28L8.5 15.61V3.72L12.5 2.39V14.28ZM18.5 15.61L14.5 14.28V2.39L18.5 3.72V15.61Z",
    fill: "#FFA024"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.080b055e18c04d9f90035ed39a41933e.svg";
export { ForwardRef as ReactComponent };